import type { LensCardData } from '~/types/leLens';

import type { Snapshot } from './data';

/** Reject incomplete counted batches before any report operands reach the model. */
function evidenceRows(cards: Array<LensCardData>, id: string): Array<Record<string, unknown>> {
  const card = cards.find((value) => value.cardId === id);
  if (!card || !['ready', 'empty'].includes(card.status)) {
    throw Error(card?.message || `${id} evidence is still loading.`);
  }
  if (card.truncated) {
    throw Error(`${id} evidence exceeds its row limit. Figures are withheld to prevent a partial benchmark.`);
  }
  return (card.rows || []).flatMap((row) => {
    const parsed: unknown = JSON.parse(String(row.payload));
    if (!Array.isArray(parsed) || parsed.length !== Number(row.record_count)) {
      throw Error(`Invalid ${id} evidence batch.`);
    }
    return parsed as Array<Record<string, unknown>>;
  });
}

export function livePost(cards: Array<LensCardData>, from: string, to: string): Snapshot {
  return {
    regionViews: evidenceRows(cards, 'region_views') as Snapshot['regionViews'],
    regionSales: evidenceRows(cards, 'region_sales') as Snapshot['regionSales'],
    parity: evidenceRows(cards, 'parity') as Snapshot['parity'],
    sales: evidenceRows(cards, 'sales') as Snapshot['sales'],
    views: evidenceRows(cards, 'views') as Snapshot['views'],
    campaigns: evidenceRows(cards, 'campaigns') as Snapshot['campaigns'],
    meta: { asOf: to, from, extractedAt: new Date().toISOString(), sources: {} },
  };
}
